/// <reference types="cookiebot-sdk" />
import { isOnPremise } from 'bones/utils/portal/environment';

class CookiebotAgent {
  loaded = false;

  initialLoadCompleted = false;

  load() {
    const cookiebotId = process.env.COOKIEBOT_ID;
    if (!cookiebotId || isOnPremise()) {
      return;
    }

    if (!this.loaded) {
      const script = document.createElement('script');
      script.setAttribute('id', 'Cookiebot');
      script.setAttribute('src', 'https://consent.cookiebot.com/uc.js');
      script.setAttribute('data-cbid', cookiebotId);
      script.setAttribute('data-blockingmode', 'auto');
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('data-widget-enabled', 'false');
      document.head.prepend(script);

      this.loaded = true;

      window.addEventListener('CookiebotOnConsentReady', () => {
        // reload the page if consent has changed, but not on initial load
        if (this.initialLoadCompleted) {
          window.location.reload();
        }
        this.initialLoadCompleted = true;
      });
    }
  }

  openDialog() {
    if (this.loaded && window.Cookiebot) {
      window.Cookiebot.renew();
    }
  }
}

export const cookiebotAgent = new CookiebotAgent();
